import { MediaService, MediaTokenProvider, DefaultConnectionParams } from '@withso/pop-media-sdk';
import { LiveKitProvider } from '@withso/pop-media-livekit';
import client from '@api/client';

// FIXME: we have to async request providers from the server
// because the values aren't known at build time... there must
// be a better way!
export const readyPromise = client.getMediaProviders().then((providers) => {
  console.log('[DEBUG Media] getMediaProviders returned:', JSON.stringify(providers, null, 2));
  if (providers.livekit) {
    console.log('[DEBUG Media] Initializing LiveKitProvider with endpoint:', providers.livekit.endpoint);
    (media as any).providers.livekit = new LiveKitProvider(providers.livekit.endpoint);
    // Explicitly set as active provider to ensure getParticipantTrack usage
    // Use Object.defineProperty to overwrite the getter on this instance
    const livekitProvider = (media as any).providers.livekit;
    // Force active provider to be LiveKit
    Object.defineProperty(media, 'activeProvider', {
      get: () => (media as any).providers.livekit,
      configurable: true
    });
    console.log('[DEBUG Media] Overwrote activeProvider getter to return LiveKitProvider');

    // Manually relay events from provider to media service to ensure state updates
    const provider = (media as any).providers.livekit;
    const relayEvents = ['trackStarted', 'trackStopped', 'participantConnected', 'participantDisconnected', 'disconnected'];
    relayEvents.forEach(event => {
      provider.on(event, (...args: any[]) => {
        console.log(`[DEBUG Media] Relaying ${event} from LiveKitProvider`, args);
        media.emit(event as any, ...args);
      });
    });

    // Wrap media.getParticipantTrack to Bypass MediaService internal cache failures
    const originalServiceGet = media.getParticipantTrack.bind(media);
    media.getParticipantTrack = (participantId: string, trackType: any) => {
      // First try original service (likely fails returning null)
      const result = originalServiceGet(participantId, trackType);
      
      if (result) return result;

      // Fallback: Query LiveKitProvider directly
      // This bypasses MediaService's broken participant state
      const provider = (media as any).providers.livekit;
      if (provider) {
        const directTrack = provider.getMediaStreamTrack(participantId, trackType);

        if (directTrack) {
           return directTrack;
        }
      }
      
      return null;
    };
  } else {
    console.warn('[DEBUG Media] No livekit provider found in response');
  }
  if (Object.keys(providers).length === 0) {
    console.error('[DEBUG Media] readyPromise found NO providers!');
    throw new Error('No media providers configured');
  }
  console.log('[DEBUG Media] readyPromise resolved. Providers attached:', Object.keys((media as any).providers));
  return providers;
});

class TokenProvider implements MediaTokenProvider<DefaultConnectionParams & { roomRoute: string }> {
  getToken = async ({ roomRoute }: { roomRoute: string }) => {
    const token = await client.connectToMeeting(roomRoute);
    return token;
  };
}

export const media = new MediaService<TokenProvider>({
  providers: {},
  tokenProvider: new TokenProvider(),
});
